import { ChevronLeft, ChevronRight, X } from "lucide-react";
import logoImage from "../../../../../assets/img/nova-logo-branca.png";
import { cn } from "../../../../lib/utils.js";
import { Button } from "../../../ui/button.js";
import { SIDEBAR_UI_CONFIG } from "../constants/sidebar-ui-config.js";

/**
 * Cabeçalho da sidebar (logo + controles de colapso/fechar).
 */
export function SidebarHeader({
  collapsed,
  isMobile,
  isCollapsedLogoHovered,
  onCollapsedLogoHoverEnter,
  onCollapsedLogoHoverLeave,
  onCollapsedLogoFocus,
  onCollapsedLogoBlur,
  onCollapse,
  onExpand,
  onCloseMobile,
  onExpandedLogoClick,
}) {
  const { header } = SIDEBAR_UI_CONFIG;

  return (
    <div
      className={cn(
        "flex flex-shrink-0 items-center border-b border-gray-800 transition-all duration-200",
        collapsed && !isMobile ? "px-3 py-3" : "px-4 py-3",
      )}
    >
      {!collapsed || isMobile ? (
        <div className="flex w-full items-center justify-between">
          <button
            type="button"
            onClick={onExpandedLogoClick}
            className={header.expandedLogoButton}
            aria-label={header.logoNavigateLabel}
          >
            <img
              src={logoImage}
              alt={header.logoAlt}
              className={header.expandedLogoImage}
            />
          </button>
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={onCollapse}
              className="hidden h-8 w-8 items-center justify-center rounded-md text-gray-400 hover:bg-gray-900 hover:text-white lg:flex"
            >
              <ChevronLeft size={16} />
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={onCloseMobile}
              className="h-8 w-8 items-center justify-center rounded-md text-gray-400 hover:bg-gray-900 hover:text-white lg:hidden"
            >
              <X size={16} />
            </Button>
          </div>
        </div>
      ) : (
        <div
          className="group relative flex w-full items-center justify-center"
          onMouseEnter={onCollapsedLogoHoverEnter}
          onMouseLeave={onCollapsedLogoHoverLeave}
          onFocus={onCollapsedLogoFocus}
          onBlur={onCollapsedLogoBlur}
          tabIndex={-1}
        >
          <img
            src={logoImage}
            alt={header.logoAlt}
            className={cn(
              header.collapsedLogoImage,
              isCollapsedLogoHovered && "opacity-0",
            )}
            aria-hidden={isCollapsedLogoHovered}
          />
          <Button
            variant="ghost"
            size="sm"
            onClick={onExpand}
            className={cn(
              "absolute hidden h-8 w-8 items-center justify-center rounded-md text-gray-400 transition-opacity hover:bg-gray-900 hover:text-white lg:flex",
              isCollapsedLogoHovered
                ? "opacity-100"
                : "pointer-events-none opacity-0",
            )}
          >
            <ChevronRight size={16} />
          </Button>
        </div>
      )}
    </div>
  );
}
